module.exports = __webpack_public_path__ + "static/media/clock.a1c6d912.png";